import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import Box from '../ui/box/Box';
import Grid from '../ui/grid/Grid';
import Typography from '../ui/typography/Typography';

const listLogo = [
	{
		id: 0,
		logo: 'alzabox.webp',
		title: 'Alzabox',
		content: ''
	},
	{
		id: 1,
		logo: 'balikobox.webp',
		title: 'Balikobox'
	},
	{
		id: 2,
		logo: 'packeta.webp',
		title: 'Packeta'
	},
	{
		id: 3,
		logo: 'sps.webp',
		title: 'Slovak Parcel Service'
	},
	{
		id: 4,
		logo: 'sofia.webp',
		title: 'Kvety Sofia floristika'
	}
];

const StyledComponent = styled(Box)(({ theme }) => ({
	'& .MuiTypography-h2': {
		marginBottom: theme.spacing(4)
	}
}));

const CollectionPointsGridLogo = () => {
	const { t } = useTranslation();

	return (
		<StyledComponent>
			<Typography variant="h2" textAlign="center" textTransform="uppercase">
				{t(`cms:category.collectionPoints.title`)}
			</Typography>

			<Grid container spacing={2} textAlign="center">
				{listLogo.map((item) => (
					<Grid key={item.id} item xs={6} sm={3} lg={2}>
						<Paper variant="outlined" sx={{ textAlign: 'center', p: 1 }}>
							<img
								alt="Logo"
								title="Logo"
								src={`/assets/collectionPoints/${item.logo}`}
								width="100%"
							/>
						</Paper>
					</Grid>
				))}
			</Grid>
		</StyledComponent>
	);
};

export default CollectionPointsGridLogo;
